module.exports = __webpack_public_path__ + "static/media/shape1.pngfeat1.2baf3914.png";